import { withAuth } from "./auth0-service";

const API_URL = import.meta.env.VITE_API_BASE_URL || "https://localhost:7122/api";

export const socialPlatformsApi = {
  messenger: {
    getAll: async () => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/FacebookAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch accounts");
      }
      return response.json();
    },
    getById: async (id) => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/FacebookAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch account");
      }
      return response.json();
    },
    create: async (data) => {
      const options = await withAuth({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...data,
          platform: "messenger",
        }),
      });
      const response = await fetch(`${API_URL}/FacebookAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to create account");
      }
      return response.json();
    },
    update: async (id, data) => {
      const options = await withAuth({
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...data,
          platform: "messenger",
        }),
      });
      const response = await fetch(`${API_URL}/FacebookAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to update account");
      }
      return response.json();
    },
    delete: async (id) => {
      const options = await withAuth({
        method: "DELETE",
      });
      const response = await fetch(`${API_URL}/FacebookAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to delete account");
      }
      return true;
    },    extendToken: async (facebookAccountId, accessToken, appId, appSecret) => {
      try {
        const options = await withAuth({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            facebookPageId: facebookAccountId,
            token: accessToken,
            appId: appId,
            appSecret: appSecret, // Include the App Secret for token extension
            request: {}, // Adding the required empty request object
          }),
        });

        const response = await fetch(
          `${API_URL}/FacebookAccount/extend-token`,
          options
        );

        if (!response.ok) {
          const error = await response.text();
          throw new Error(error || "Failed to extend Facebook token");
        }

        return response.json();
      } catch (error) {
        console.error("Error extending Facebook token:", error);
        throw error;
      }
    },
  },
  instagram: {
    getAll: async () => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/InstagramAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch accounts");
      }
      return response.json();
    },
    getById: async (id) => {
      const options = await withAuth();
      const response = await fetch(
        `${API_URL}/InstagramAccount/${id}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch account");
      }
      return response.json();
    },
    create: async (data) => {
      const options = await withAuth({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...data,
          platform: "instagram",
        }),
      });
      const response = await fetch(`${API_URL}/InstagramAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to create account");
      }
      return response.json();
    },
    update: async (id, data) => {
      const options = await withAuth({
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...data,
          platform: "instagram",
        }),
      });
      const response = await fetch(
        `${API_URL}/InstagramAccount/${id}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to update account");
      }
      return response.json();
    },
    delete: async (id) => {
      const options = await withAuth({
        method: "DELETE",
      });
      const response = await fetch(
        `${API_URL}/InstagramAccount/${id}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to delete account");
      }
      return true;
    },    extendToken: async (instagramAccountId, accessToken, appId, appSecret) => {
      try {
        const options = await withAuth({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            instagramPageId: instagramAccountId,
            token: accessToken,
            appId: appId,
            appSecret: appSecret,
            request: {}, // Adding the required empty request object
          }),
        });

        const response = await fetch(
          `${API_URL}/InstagramAccount/extend-token`,
          options
        );

        if (!response.ok) {
          const error = await response.text();
          throw new Error(error || "Failed to extend Instagram token");
        }

        return response.json();
      } catch (error) {
        console.error("Error extending Instagram token:", error);
        throw error;
      }
    },
  },
  whatsapp: {
    getAll: async () => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/WhatsAppAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch WhatsApp accounts");
      }
      return response.json();
    },
    getById: async (id) => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/WhatsAppAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch WhatsApp account");
      }
      return response.json();
    },
    create: async (data) => {
      const options = await withAuth({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data), // Don't add platform field for WhatsApp
      });
      const response = await fetch(`${API_URL}/WhatsAppAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to create WhatsApp account");
      }
      return response.json();
    },
    update: async (id, data) => {
      const options = await withAuth({
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data), // Don't add platform field for WhatsApp
      });
      const response = await fetch(`${API_URL}/WhatsAppAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to update WhatsApp account");
      }
      return response.json();
    },
    delete: async (id) => {
      const options = await withAuth({
        method: "DELETE",
      });
      const response = await fetch(`${API_URL}/WhatsAppAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to delete WhatsApp account");
      }
      return true;
    },
  },
  viber: {
    getAll: async () => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/ViberAccount`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch Viber accounts");
      }
      return response.json();
    },
    getById: async (id) => {
      const options = await withAuth();
      const response = await fetch(`${API_URL}/ViberAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch Viber account");
      }
      return response.json();
    },
    create: async (data) => {
      try {
        const options = await withAuth({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...data,
            platform: "viber",
          }),
        });

        const response = await fetch(`${API_URL}/ViberAccount`, options);

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Viber API Error:", errorText);
          throw new Error(errorText || "Failed to create Viber account");
        }

        return response.json();
      } catch (error) {
        console.error("Viber Create Error:", error);
        throw error;
      }
    },
    update: async (id, data) => {
      const options = await withAuth({
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...data,
          platform: "viber",
        }),
      });
      const response = await fetch(`${API_URL}/ViberAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to update Viber account");
      }
      return response.json();
    },
    delete: async (id) => {
      const options = await withAuth({
        method: "DELETE",
      });
      const response = await fetch(`${API_URL}/ViberAccount/${id}`, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to delete Viber account");
      }
      return true;
    },
  },
};
